
define('template!pimSearchCompareTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="pim-compare-toolbar">\n    <button class="btn btn-default btn-sm js-compare-back">\n        <i class="fa fa-arrow-left"></i> ' +
((__t = ( _.i18n('common.back', null, 'Back') )) == null ? '' : __t) +
'\n    </button>\n\n    <div class="pim-compare-title">\n        <i class="fa fa-balance-scale"></i>\n        ' +
((__t = ( _.i18n('compare.title', null, 'Compare') )) == null ? '' : __t) +
'\n        <span class="pim-compare-count">(' +
((__t = ( count )) == null ? '' : __t) +
')</span>\n    </div>\n\n    <div class="pim-compare-shared">\n        <label class="pim-compare-shared-label">' +
((__t = ( _.i18n('common.quantity', null, 'Quantity') )) == null ? '' : __t) +
'</label>\n        <input type="number" min="1" class="pim-compare-shared-qty js-compare-qty" value="' +
((__t = ( sharedQty )) == null ? '' : __t) +
'" />\n        <button class="btn btn-primary btn-sm js-compare-calc-all">\n            ' +
((__t = ( _.i18n('common.calculate', null, 'Calculate') )) == null ? '' : __t) +
'\n        </button>\n    </div>\n\n    <button class="btn btn-default btn-sm js-compare-clear-all">\n        ' +
((__t = ( _.i18n('common.clear', null, 'Clear all') )) == null ? '' : __t) +
'\n    </button>\n</div>\n\n<div class="pim-compare-columns js-compare-columns"></div>\n\n<div class="loading-block js-compare-loading loader" style="display: none;"></div>\n';

}
return __p
};});

